import * as React from 'react';
import { Paragraph2 } from '@cian/ui-kit';

interface IFinishLabelProps {
  label: string;
}

export function FinishLabel({ label }: IFinishLabelProps) {
  return <Paragraph2 color="gray40_100">{label}</Paragraph2>;
}
